/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "common": {
                            "nested": {
                              "Tipping": {
                                "fields": {
                                  "tippingEnabled": {
                                    "type": "bool",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "smartTipsEnabled": {
                                    "type": "bool",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "allowCustomAmounts": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": true
                                    }
                                  },
                                  "useSeparateTippingScreen": {
                                    "type": "bool",
                                    "id": 4,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "tipCustomPercentages": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.TipCustomPercentages",
                                    "id": 5,
                                    "rule": "optional"
                                  },
                                  "tipCalculationPhase": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.common.Tipping.TippingCalculationPhase",
                                    "id": 6,
                                    "rule": "optional",
                                    "options": {
                                      "default": "POST_TAX_TIP_CALCULATION"
                                    }
                                  },
                                  "allowRoundUp": {
                                    "type": "bool",
                                    "id": 7,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  },
                                  "preAuthTippingEnabled": {
                                    "type": "bool",
                                    "id": 8,
                                    "rule": "optional",
                                    "options": {
                                      "default": false
                                    }
                                  }
                                },
                                "nested": {
                                  "TippingCalculationPhase": {
                                    "values": {
                                      "UNKNOWN": 0,
                                      "PRE_TAX_TIP_CALCULATION": 1,
                                      "POST_TAX_TIP_CALCULATION": 2
                                    }
                                  }
                                }
                              },
                              "TipCustomPercentages": {
                                "fields": {
                                  "firstAmount": {
                                    "type": "int32",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": 15
                                    }
                                  },
                                  "secondAmount": {
                                    "type": "int32",
                                    "id": 2,
                                    "rule": "optional",
                                    "options": {
                                      "default": 20
                                    }
                                  },
                                  "thirdAmount": {
                                    "type": "int32",
                                    "id": 3,
                                    "rule": "optional",
                                    "options": {
                                      "default": 25
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Tipping && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.Tipping?.nested?.TippingCalculationPhase && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.common?.nested?.TipCustomPercentages) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE Tipping @ squareup/devicesettings/profiles/v2/model/settings/common/tipping.proto at 16:1
 */
export const Tipping = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.Tipping');
fixType(Tipping);
Builder.createAndAttachToType(Tipping);
/**
 * SOURCE TippingCalculationPhase @ squareup/devicesettings/profiles/v2/model/settings/common/tipping.proto at 25:3
 */
Tipping.TippingCalculationPhase = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.common.Tipping.TippingCalculationPhase').values;
/**
 * SOURCE TipCustomPercentages @ squareup/devicesettings/profiles/v2/model/settings/common/tipping.proto at 32:1
 */
export const TipCustomPercentages = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.common.TipCustomPercentages');
fixType(TipCustomPercentages);
Builder.createAndAttachToType(TipCustomPercentages);